exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "button.vs__deselect[data-v-96e3eb84] {\n  display: none !important;\n}\n", ""]);

// exports
